import { render, staticRenderFns } from "./contentLearnerCreateWithCourse.vue?vue&type=template&id=068d888e&"
import script from "./contentLearnerCreateWithCourse.vue?vue&type=script&lang=js&"
export * from "./contentLearnerCreateWithCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports